import React from "react";
import ChatLink from "~/common/ChatLink";

const ChatButton = ({
  link = "/chat/",
  target = "_blank",
  text = "Chat Now",
  statusText = "online",
  className = "",
}) => {
  const buttonDisabled = statusText === "offline";

  return (
    <ChatLink
      href={statusText === "online" ? link : ""}
      id="chat-button"
      target={target}
      className={`group inline-flex float-left mt-0 no-underline hover:no-underline ${className}${
        buttonDisabled ? "cursor-not-allowed pointer-events-none" : ""
      }`}
      aria-label="chat now with customer service, opens in a new window"
      disabled={buttonDisabled}
      aria-describedby="statusText"
      aria-disabled={buttonDisabled}
      tabIndex={buttonDisabled ? -1 : undefined}
      data-testid="chat-button"
    >
      <>
        <div
          className={`flex bg-blue-700 text-white w-25 h-7 rounded-l-md border border-black border-opacity-10 px-2 items-center ${
            !buttonDisabled ? "hover:bg-blue-800 hover:underline" : ""
          }`}
        >
          <svg
            id="chat"
            width="16"
            height="16"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden
          >
            <path
              d="M8.94786 18.0001L4 22.0001V6.00006C4 5.73484 4.10536 5.48049 4.29289 5.29295C4.48043 5.10542 4.73478 5.00006 5 5.00006H21C21.2652 5.00006 21.5196 5.10542 21.7071 5.29295C21.8946 5.48049 22 5.73484 22 6.00006V17.0001C22 17.2653 21.8946 17.5196 21.7071 17.7072C21.5196 17.8947 21.2652 18.0001 21 18.0001H8.94786Z"
              stroke="white"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M10 18.0001V23.0001C10 23.2653 10.1054 23.5196 10.2929 23.7072C10.4804 23.8947 10.7348 24.0001 11 24.0001H23.0521L28 28.0001V12.0001C28 11.7348 27.8946 11.4805 27.7071 11.293C27.5196 11.1054 27.2652 11.0001 27 11.0001H22"
              stroke="white"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <span className="ml-1 text-sm font-semibold">{text}</span>
        </div>

        <span
          id="statusText"
          className="bg-white rounded-r-md border border-gray-400 text-sm font-semibold capitalize border-l-transparent border-solid text-black px-1.5 pt-1"
        >
          {statusText}
        </span>
      </>
    </ChatLink>
  );
};

export default ChatButton;
